// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getBrandRequest: ['data'],
  getBrandSuccess: ['data'],
  getBrandFailure: ['err'],

  createBrandRequest: ['data'],
  createBrandSuccess: ['data'],
  createBrandFailure: ['err'],

  updateBrandRequest: ['data'],
  updateBrandSuccess: ['data'],
  updateBrandFailure: ['err'],

  deleteBrandRequest: ['data'],
  deleteBrandSuccess: ['data'],
  deleteBrandFailure: ['err'],

  getSingleBrandRequest: ['data'],
  getSingleBrandSuccess: ['data'],
  getSingleBrandFailure: ['err'],

  createCategoryBrandRequest: ['data'],
  createCategoryBrandSuccess: ['data'],
  createCategoryBrandFailure: ['err'],

  updateCategoryBrandRequest: ['data'],
  updateCategoryBrandSuccess: ['data'],
  updateCategoryBrandFailure: ['err'],

  deleteCategoryBrandRequest: ['data'],
  deleteCategoryBrandSuccess: ['data'],
  deleteCategoryBrandFailure: ['err']

})

export const BrandTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_BRAND_SUCCESS]: success,
  [Types.GET_BRAND_REQUEST]: request,
  [Types.GET_BRAND_FAILURE]: failure,

  [Types.CREATE_BRAND_SUCCESS]: success,
  [Types.CREATE_BRAND_REQUEST]: request,
  [Types.CREATE_BRAND_FAILURE]: failure,

  [Types.UPDATE_BRAND_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_BRAND_REQUEST]: manipulateRequest,
  [Types.UPDATE_BRAND_FAILURE]: manipulateFailure,

  [Types.DELETE_BRAND_SUCCESS]: manipulateSuccess,
  [Types.DELETE_BRAND_REQUEST]: manipulateRequest,
  [Types.DELETE_BRAND_FAILURE]: manipulateFailure,

  [Types.GET_SINGLE_BRAND_SUCCESS]: success,
  [Types.GET_SINGLE_BRAND_REQUEST]: request,
  [Types.GET_SINGLE_BRAND_FAILURE]: failure,

  [Types.CREATE_CATEGORY_BRAND_SUCCESS]: success,
  [Types.CREATE_CATEGORY_BRAND_REQUEST]: request,
  [Types.CREATE_CATEGORY_BRAND_FAILURE]: failure,

  [Types.UPDATE_CATEGORY_BRAND_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_CATEGORY_BRAND_REQUEST]: manipulateRequest,
  [Types.UPDATE_CATEGORY_BRAND_FAILURE]: manipulateFailure,

  [Types.DELETE_CATEGORY_BRAND_SUCCESS]: manipulateSuccess,
  [Types.DELETE_CATEGORY_BRAND_REQUEST]: manipulateRequest,
  [Types.DELETE_CATEGORY_BRAND_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/BrandRedux.js